module.exports = __webpack_public_path__ + "res/Roboto-LightItalic-webfont.eot?5a08ee6234e996ff8af68b0af3f9e656";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-LightItalic-webfont.eot
// module id = 71
// module chunks = 0